<template>
  <a
    :href="cms.href.url"
    :class="[name, buttonClass]"
    :title="copy"
    :target="blank"
  >
    <i
      v-if="cms.showIcon"
      :class="[`${name}__icon`, `${name}__icon-before`, icon]"
    ></i>
    <template v-if="cms.type !== 'iconography'">
      {{ copy }}
    </template>
    <i
      v-if="iconRight"
      :class="[`${name}__icon`, `${name}__icon-after`, iconRight]"
    >
    </i>
  </a>
</template>

<script>
import data from '~/components/atoms/a-ctas/a-cta-v2.data'

export default {
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },
  data() {
    return {
      name: 'a-cta',
    }
  },
  computed: {
    copy() {
      return this.cms.copy || ''
    },
    icon() {
      return this.cms.icon ? this.cms.icon : 'icon-arrow-right'
    },
    iconRight() {
      return this.cms.icon_right ? this.cms.icon_right : ''
    },
    buttonClass() {
      return `${this.name}__${this.cms.type}`
    },
  },
}
</script>
<style lang="scss" scoped>
.a-cta {
  @include font-size(16, 24px);

  align-items: center;
  background-clip: padding-box;
  background-color: transparent;
  display: inline-block;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  // text-align: center;

  &__icon {
    vertical-align: inherit;
    display: inline-block;
    position: relative;
  }

  &:not(&__iconography) {
    .a-cta__icon-before {
      padding-right: 10px;
    }

    .a-cta__icon-after {
      padding-left: 10px;
    }
  }

  &__primary {
    padding: 10px 52px;
    border: 1px solid;
    border-radius: 2px;
    color: inherit;

    &:hover {
      border: 1px solid;
      background-color: transparent;
      color: inherit;
    }
  }

  &__secondary {
    color: inherit;

    &:hover {
      background-color: transparent;
      color: inherit;
    }
  }
  &__tertiary {
    padding: 12px 60px;
    border-radius: 2px;
    background-color: $gray-150;

    &:hover {
      background-color: $supernova;
    }
  }
}

@include media-breakpoint-up(sm) {
  .a-cta {
    text-align: initial;
    width: auto;
  }
}
</style>
